export const FETCH_BULK_REPORT_REQUESTS = 'src/components/Corporate/bulk-case-request/action/Fetch_Bulk_Report_Requests';
export const FETCH_BULK_REPORT_REQUESTS_SUCCESS = 'src/components/Corporate/bulk-case-request/action/Fetch_Bulk_Report_Requests_Success';
export const FETCH_BULK_REPORT_REQUESTS_FAILURE = 'src/components/Corporate/bulk-case-request/action/Fetch_Bulk_Report_Requests_Failure';
export const fetchBulkReportRequests = (data) => {
    return {
        type: FETCH_BULK_REPORT_REQUESTS,
        data
    }
}
export const fetchBulkReportRequestsSuccess = (data) => {
    return {
        type: FETCH_BULK_REPORT_REQUESTS_SUCCESS,
        data
    }
}
export const fetchBulkReportRequestsFailure = (error) => {
    return {
        type: FETCH_BULK_REPORT_REQUESTS_FAILURE,
        error
    }
}

export const DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE = 'src/components/Corporate/bulk-case-request/action/Download_Bulk_Report_Request_Template';
export const DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE_SUCCESS = 'src/components/Corporate/bulk-case-request/action/Download_Bulk_Report_Request_Template_Success';
export const DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE_FAILURE = 'src/components/Corporate/bulk-case-request/action/Download_Bulk_Report_Request_Template_Failure';
export const downloadBulkReportRequestTemplate = (data) => {
    return {
        type: DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE,
        data
    }
}
export const downloadBulkReportRequestTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadBulkReportRequestTemplateFailure = (error) => {
    return {
        type: DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE_FAILURE,
        error
    }
}

export const SUBMIT_BULK_REPORT_REQUEST = 'src/components/Corporate/bulk-case-request/action/Submit_Bulk_Report_Request';
export const SUBMIT_BULK_REPORT_REQUEST_SUCCESS = 'src/components/Corporate/bulk-case-request/action/Submit_Bulk_Report_Request_Success';
export const SUBMIT_BULK_REPORT_REQUEST_FAILURE = 'src/components/Corporate/bulk-case-request/action/Submit_Bulk_Report_Request_Failure';
export const submitBulkReportRequest = (data) => {
    return {
        type: SUBMIT_BULK_REPORT_REQUEST,
        data
    }
}
export const submitBulkReportRequestSuccess = (data) => {
    return {
        type: SUBMIT_BULK_REPORT_REQUEST_SUCCESS,
        data
    }
}
export const submitBulkReportRequestFailure = (error) => {
    return {
        type: SUBMIT_BULK_REPORT_REQUEST_FAILURE,
        error
    }
}

export const DOWNLOAD_RECORD_REQUEST_FILE = 'src/components/Corporate/bulk-case-request/action/Download_Record_Request_File';
export const DOWNLOAD_RECORD_REQUEST_FILE_SUCCESS = 'src/components/Corporate/bulk-case-request/action/Download_Record_Request_File_Success';
export const DOWNLOAD_RECORD_REQUEST_FILE_FAILURE = 'src/components/Corporate/bulk-case-request/action/Download_Record_Request_File_Failure';
export const downloadRecordRequestFile = (data) => {
    return {
        type: DOWNLOAD_RECORD_REQUEST_FILE,
        data
    }
}
export const downloadRecordRequestFileSuccess = (data) => {
    return {
        type: DOWNLOAD_RECORD_REQUEST_FILE_SUCCESS,
        data
    }
}
export const downloadRecordRequestFileFailure = (error) => {
    return {
        type: DOWNLOAD_RECORD_REQUEST_FILE_FAILURE,
        error
    }
}